import { Component } from '@angular/core';

@Component({
  selector: 'rs-popup',
  templateUrl: 'popup.component.html'
})
export class PopupComponent {}
